import { createApiRef } from '@backstage/core-plugin-api';
import {
  Metric,
  MetricDashboard,
  TopCatalogEntity,
  TopSearchTopic,
  TopTechDocsPage,
} from '@appfolio/backstage-plugin-metrics-common';

export const metricsApiRef = createApiRef<MetricsApi>({
  id: 'plugin.appfolio-metrics.service',
});

export type MetricsApiOptions = {
  start?: string;
  end?: string;
  group?: string;
  repo?: string;
  enabledFlags?: string[];
};

export interface MetricsApi {
  getDashboards(options?: MetricsApiOptions): Promise<MetricDashboard[]>;
  getMetrics(
    dashboardId: string,
    options?: MetricsApiOptions,
  ): Promise<Metric[]>;
  getMetric(
    dashboardId: string,
    metricId: string,
    options?: MetricsApiOptions,
  ): Promise<Metric>;
  getTopTechDocsPages(
    limit: number,
    options?: { start?: string; end?: string },
  ): Promise<TopTechDocsPage[]>;
  getTopCatalogEntities(
    limit: number,
    options?: { start?: string; end?: string },
  ): Promise<TopCatalogEntity[]>;
  getTopSearchTopics(): Promise<TopSearchTopic[]>;
}
